module.exports = __webpack_public_path__ + "img/android-pre-code.a7deb63.png";